// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FourthBlock_root__cVt8d {
  padding: 40px 0;
}
.FourthBlock_root__cVt8d .FourthBlock_titleBlock__K2WT9 {
  margin-bottom: 40px;
}
.FourthBlock_root__cVt8d .FourthBlock_titleBlock__K2WT9 p {
  font-size: 26px;
  font-weight: bold;
  color: #00377c;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp {
  display: flex;
  justify-content: center;
  align-items: center;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(4, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  text-align: center;
  color: #fff;
  background: #284480;
  border-radius: 20px;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV:first-child {
  grid-area: 2/2/3/3;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV:nth-child(2) {
  grid-area: 1/1/2/2;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV:nth-child(3) {
  grid-area: 2/1/3/2;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV:nth-child(4) {
  grid-area: 3/1/4/2;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV:nth-child(5) {
  grid-area: 4/1/5/2;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV:nth-child(6) {
  grid-area: 1/3/2/4;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV:nth-child(7) {
  grid-area: 2/3/3/4;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV:nth-child(8) {
  grid-area: 3/3/4/4;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV:last-child {
  grid-area: 4/3/5/4;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV .FourthBlock_infoBlock__eJRtG {
  white-space: nowrap;
  font-size: 14px;
}
.FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV .FourthBlock_infoBlock__eJRtG .FourthBlock_checkListText__wUHQ9 {
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .FourthBlock_root__cVt8d {
    padding: 20px 0;
  }
  .FourthBlock_root__cVt8d .FourthBlock_titleBlock__K2WT9 {
    margin-bottom: 20px;
  }
  .FourthBlock_root__cVt8d .FourthBlock_titleBlock__K2WT9 p {
    font-size: 18px;
  }
  .FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF {
    display: block !important;
  }
  .FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV {
    justify-content: flex-start !important;
    margin: 15px 0;
    padding: 0 !important;
    text-align: left !important;
    color: #284480 !important;
    background: none !important;
    border-radius: 0 !important;
  }
  .FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV .FourthBlock_adaptiveBlock__CAMsA {
    display: flex;
    align-items: center;
  }
  .FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV .FourthBlock_adaptiveBlock__CAMsA .FourthBlock_imageBlock__brXeS img {
    width: 50px !important;
  }
  .FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV .FourthBlock_adaptiveBlock__CAMsA .FourthBlock_infoBlock__eJRtG {
    white-space: inherit !important;
    margin-left: 15px !important;
  }
}
@media (max-width: 480px) {
  .FourthBlock_root__cVt8d .FourthBlock_titleBlock__K2WT9 p {
    font-size: 16px;
  }
  .FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV {
    margin: 10px 0 !important;
  }
  .FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV .FourthBlock_imageBlock__brXeS img {
    width: 40px !important;
  }
  .FourthBlock_root__cVt8d .FourthBlock_wrapper__L2JPp .FourthBlock_infrastructureBlock__rcAKF .FourthBlock_block__zSGRV .FourthBlock_infoBlock__eJRtG {
    margin-left: 10px !important;
    font-size: 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MainBlock/FourthBlock/FourthBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AACN;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;AAGI;EACE,aAAA;EACA,qCAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;AADN;AAGM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AADR;AAGQ;EACE,kBAAA;AADV;AAIQ;EACE,kBAAA;AAFV;AAKQ;EACE,kBAAA;AAHV;AAMQ;EACE,kBAAA;AAJV;AAOQ;EACE,kBAAA;AALV;AAQQ;EACE,kBAAA;AANV;AASQ;EACE,kBAAA;AAPV;AAUQ;EACE,kBAAA;AARV;AAWQ;EACE,kBAAA;AATV;AAYQ;EACE,mBAAA;EACA,eAAA;AAVV;AAYU;EACE,mBAAA;AAVZ;;AAkBA;EACE;IACE,eAAA;EAfF;EAiBE;IACE,mBAAA;EAfJ;EAiBI;IACE,eAAA;EAfN;EAoBI;IACE,yBAAA;EAlBN;EAoBM;IACE,sCAAA;IACA,cAAA;IACA,qBAAA;IACA,2BAAA;IACA,yBAAA;IACA,2BAAA;IACA,2BAAA;EAlBR;EAoBQ;IACE,aAAA;IACA,mBAAA;EAlBV;EAqBY;IACE,sBAAA;EAnBd;EAuBU;IACE,+BAAA;IACA,4BAAA;EArBZ;AACF;AA6BA;EAGM;IACE,eAAA;EA7BN;EAmCM;IACE,yBAAA;EAjCR;EAoCU;IACE,sBAAA;EAlCZ;EAsCQ;IACE,4BAAA;IACA,0BAAA;EApCV;AACF","sourcesContent":[".root {\n  padding: 40px 0;\n\n  .titleBlock {\n    margin-bottom: 40px;\n\n    p {\n      font-size: 26px;\n      font-weight: bold;\n      color: #00377c;\n    }\n  }\n\n  .wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .infrastructureBlock {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      grid-template-rows: repeat(4, 1fr);\n      grid-column-gap: 10px;\n      grid-row-gap: 10px;\n\n      .block {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 10px;\n        text-align: center;\n        color: #fff;\n        background: #284480;\n        border-radius: 20px;\n\n        &:first-child {\n          grid-area: 2 / 2 / 3 / 3;\n        }\n\n        &:nth-child(2) {\n          grid-area: 1 / 1 / 2 / 2;\n        }\n\n        &:nth-child(3) {\n          grid-area: 2 / 1 / 3 / 2;\n        }\n\n        &:nth-child(4) {\n          grid-area: 3 / 1 / 4 / 2;\n        }\n\n        &:nth-child(5) {\n          grid-area: 4 / 1 / 5 / 2;\n        }\n\n        &:nth-child(6) {\n          grid-area: 1 / 3 / 2 / 4;\n        }\n\n        &:nth-child(7) {\n          grid-area: 2 / 3 / 3 / 4;\n        }\n\n        &:nth-child(8) {\n          grid-area: 3 / 3 / 4 / 4;\n        }\n\n        &:last-child {\n          grid-area: 4 / 3 / 5 / 4;\n        }\n\n        .infoBlock {\n          white-space: nowrap;\n          font-size: 14px;\n\n          .checkListText {\n            margin-bottom: 10px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .root {\n    padding: 20px 0;\n\n    .titleBlock {\n      margin-bottom: 20px;\n\n      p {\n        font-size: 18px;\n      }\n    }\n\n    .wrapper {\n      .infrastructureBlock {\n        display: block !important;\n\n        .block {\n          justify-content: flex-start !important;\n          margin: 15px 0;\n          padding: 0 !important;\n          text-align: left !important;\n          color: #284480 !important;\n          background: none !important;\n          border-radius: 0 !important;\n\n          .adaptiveBlock {\n            display: flex;\n            align-items: center;\n\n            .imageBlock {\n              img {\n                width: 50px !important;\n              }\n            }\n\n            .infoBlock {\n              white-space: inherit !important;\n              margin-left: 15px !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .root {\n    .titleBlock {\n      p {\n        font-size: 16px;\n      }\n    }\n\n    .wrapper {\n      .infrastructureBlock {\n        .block {\n          margin: 10px 0 !important;\n\n          .imageBlock {\n            img {\n              width: 40px !important;\n            }\n          }\n\n          .infoBlock {\n            margin-left: 10px !important;\n            font-size: 12px !important;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `FourthBlock_root__cVt8d`,
	"titleBlock": `FourthBlock_titleBlock__K2WT9`,
	"wrapper": `FourthBlock_wrapper__L2JPp`,
	"infrastructureBlock": `FourthBlock_infrastructureBlock__rcAKF`,
	"block": `FourthBlock_block__zSGRV`,
	"infoBlock": `FourthBlock_infoBlock__eJRtG`,
	"checkListText": `FourthBlock_checkListText__wUHQ9`,
	"adaptiveBlock": `FourthBlock_adaptiveBlock__CAMsA`,
	"imageBlock": `FourthBlock_imageBlock__brXeS`
};
export default ___CSS_LOADER_EXPORT___;
